import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal, updateModalDisableOutsideClickDismiss} from '@Components/modal-container/modal-container-reducer';
import {useAppSelector} from '@/hooks';
import {LayeringType} from '@Libraries/layering-type';
import {MODAL_BORDER_RADIUS, PANEL_ID} from './make-text-editable-loading-modal.types';

export default function MakeTextEditableLoadingModal(): ReactElement {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.MAKE_TEXT_EDITABLE_LOADING_MODAL];
  });

  return (
    <Modal
      modalId={MODALS_IDS.MAKE_TEXT_EDITABLE_LOADING_MODAL}
      modalMaxHeight="fit-content"
      modalHeight="fit-content"
      modalMaxWidth="500px"
      modalBorderRadius={MODAL_BORDER_RADIUS}
      panelId={PANEL_ID}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="make-text-editable-loading-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const openMakeTextEditableLoadingModal = (layeringType: LayeringType = LayeringType.TEXT): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.MAKE_TEXT_EDITABLE_LOADING_MODAL,
      panelProps: {layeringType},
      isDismissible: false,
    })
  );
  window.PMW.redux.store.dispatch(
    updateModalDisableOutsideClickDismiss({
      modalId: MODALS_IDS.MAKE_TEXT_EDITABLE_LOADING_MODAL,
      disableOutsideClickDismiss: true,
    })
  );
};
